import { render, staticRenderFns } from "./TabelaFreteForm.vue?vue&type=template&id=4c3f3706"
import script from "./TabelaFreteForm.vue?vue&type=script&lang=js"
export * from "./TabelaFreteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports